module.exports = __webpack_public_path__ + "img/品質管理4-9.9873e8f3.png";